import { ROLE_ENTITY_TYPE, RoleAddon, roleMetadata } from "./RoleAddon/RoleAddon";
import { EntityRelationValidationAddon } from "./EntityRelationValidation/EntityRelationValidationAddon";
import { EntityRegistry } from "./EntityRelationsManager";
import {
  BUSINESS_AREA_ENTITY_TYPE,
  BusinessAreaAddon,
  businessAreaMetadata
} from "./BusinessAreaAddon/BusinessAreaAddon";
import { StepChangeEvent } from "../../types/types";

export const createEntityRegistry = (): EntityRegistry => {
  return {
    [BUSINESS_AREA_ENTITY_TYPE]: {
      addon: BusinessAreaAddon,
      metadata: businessAreaMetadata
    },
    [ROLE_ENTITY_TYPE]: {
      addon: RoleAddon,
      metadata: roleMetadata
    }
  };
};

export const setupUploader = () => {
  const entityRegistry = createEntityRegistry();

  const createEntityAddons = (onNext: (event: StepChangeEvent) => void, onBack: () => void, params: any) => {
    const businessAreaAddon = new BusinessAreaAddon(onNext, onBack, params);
    const roleAddon = new RoleAddon(onNext, onBack, params);

    return [businessAreaAddon, roleAddon];
  };

  const createEntityRelationValidationAddon = (
    onNext: (event: StepChangeEvent) => void,
    onBack: () => void,
    params: any
  ) => {
    const entityAddons = createEntityAddons(onNext, onBack, params);

    return new EntityRelationValidationAddon(onNext, onBack, {
      ...params,
      entityRegistry,
      entityRelationAddons: entityAddons
    });
  };

  return {
    createEntityRelationValidationAddon,
    entityRegistry
  };
};
